<template>
    <div>
        
    </div>
</template>
<script>
    export default {
        data() {
            return {

            }
        },
        created() {

        },
        methods: {

        }
    }
</script>   


// WEBPACK FOOTER //
// src/views/index.vue